import type { PartnerAddressV2, PartnerTenant } from '@shipium-corp/shipium-ts-types';
import type { HydrationAssetError } from '../types';
import { extractTenantDetails, findScopedTenant, generateHydrationError, isActiveAsset } from './utils';
const addressAssetType = 'address';

export const hydrateAddress = (tenantList: PartnerTenant[], address?: PartnerAddressV2) => {
  const notActive =
    !isActiveAsset(address) && address ? generateHydrationError('Not configured', addressAssetType) : null;
  const notLinked = !address ? generateHydrationError('Not configured', addressAssetType) : null;
  const noTimezone = !address?.location?.validatedAddressMetadata?.timeZoneId
    ? generateHydrationError('Not configured', addressAssetType)
    : null;
  const tenant = address ? findScopedTenant(address.addressId!, 'addresses', tenantList) : null;
  const errors: HydrationAssetError[] = [notActive, notLinked, noTimezone].filter(
    (err): err is HydrationAssetError => !!err,
  );
  return {
    ...(address ?? {}),
    ...(tenant ? { tenant: extractTenantDetails(tenant) } : {}),
    validationInfo: {
      errors,
      configurationValid: !errors.length,
      warnings: [],
      configurationComplete: !errors.length,
    },
  };
};
